import { render, staticRenderFns } from "./DetailProject.vue?vue&type=template&id=0375f0ae&"
import script from "./DetailProject.vue?vue&type=script&lang=js&"
export * from "./DetailProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports